/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
/* eslint-disable no-return-assign */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
import dynamic from "next/dynamic";
import PropTypes from "prop-types";
import Cookies from "js-cookie";
import {
	useCallback, useEffect, useRef, useState,
} from "react";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";

import SubNav from "@fdn/sub_nav";
import NavbarHeader from "@fdn/navbar_header";
import AlloMain from "@fdn/allo_profile_migration";
import Banner from "Components/banner/banner";
import ModalCompleteProfileCta from "Components/modal_complete_profile_cta/modal_complete_profile_cta";
import ScrollTop from "Components/scroll_top/scrollTop";

import {
	Fetching,
	ScrollToUp,
	setDataLayer,
} from "Helpers/utils";
import { encryptString } from "Helpers/encrypt";
import Env from "Consts/env";
import Vars from "Consts/vars";

import { loadCompleting } from "Store/completing/lib/actions";
import { loadSearchDefault } from "Store/SearchDefault/lib/actions";
import { loadQuickSearch } from "Store/QuickSearch/lib/actions";
import { FcmNotification } from "Components/fcm/FcmNotif";
import Notification from "Components/fcm/index";

import { checkLoginStatus } from "Utils/checkLogin";
import { fetchFcmDelete } from "Utils/http/delete";
import { getNotification } from "Helpers/fetch";
import ModalWarning from "Components/modal_warning";
import SearchDefault from "./search_default/searchDefault";
import QuickSearch from "./quick_search/quickSearch";

const Category = dynamic(() => import("Components/category"), {
	ssr: false,
});

const AlloSectionProfilePopup = dynamic(
	() => import("Components/allo/AlloProfilePopupSection"), {
		ssr: true,
	},
);

const AlloExploreModal = dynamic(
	() => import("Components/modal/alloExplore/AlloExploreModal"), {
		ssr: true,
	},
);

const Footer = dynamic(() => import("Components/footer"), {
	ssr: false,
});

const Layout = ({ ...props }) => {

	const isMobile = props.ismobile || false;

	useCallback(() => {

		ScrollToUp();

	}, []);

	const dispatch = useDispatch();
	const getData = useSelector((state) => state);
	const router = useRouter();
	const ref = useRef(null);

	const [historyHeight, setHistoryHeight] = useState(0);
	const [expandHistory, setExpandHistory] = useState(true);

	const [TotalNotifReviews, setTotalNotifReviews] = useState(0);
	const [TotalNotifTalks, setTotalNotifTalks] = useState(0);
	const [bannerRibbon, setBannerRibbon] = useState([]);
	const [navHeight, setNavHeight] = useState(0);

	const [searchCampaign, setSeacrhCampaign] = useState([]);

	const [searchText, setSearchText] = useState("");
	const [isShowSearch, setShowSearch] = useState(false);
	const [isShowSearchResult, setShowSearchResult] = useState(false);
	const [isShowSearchInput, setShowSearchInput] = useState(false);

	// category tab state
	const [isShowCategoryMenu, setIsShowCategoryMenu] = useState(false);
	const [isCategorySidebarOpen, setIsCategorySidebarOpen] = useState(false);
	const [isShowSidebar, setIsShowSidebar] = useState(false);

	const [isHidetopMenu, setToggleTopMenu] = useState(false);
	const [isShowModalAdd, setIsShowModalAdd] = useState(false);
	const [isVisible, setIsVisible] = useState(false);

	const [isAlloExplorePopup, setIsAlloExplorePopup] = useState(false);
	const [IsShowAlloPopup, SetIsShowAlloPopup] = useState(false);

	const [isModalCompleteProfileCta, setModalCompleteProfileCta] = useState(false);
	const [DataHistory, setDataHistory] = useState([]);
	const [IsLoadingSearch, setIsLoadingSearch] = useState(false);
	const [IsLoadingDefault, setIsLoadingDefault] = useState(false);
	const [isNotifBadge, setIsNotifBadge] = useState(false);

	const calculateCompletingPercentage = () => {

		let completing;

		const dataComplete = getData.storeCompleting?.data?.data;
		const profileDataStep = Array.isArray(dataComplete?.step) ? dataComplete.step : [];

		if (process.env.NEXT_PUBLIC_ALLO_STATUS === "ON") {

			completing = {
				personalInfo: profileDataStep?.filter((complete) => complete.step === "complete_personal_info" && complete.status === true).length > 0,
				beautyProfile: profileDataStep?.filter((complete) => complete.step === "complete_skin_profile" && complete.status === true).length > 0 && profileDataStep?.filter((complete) => complete.step === "complete_hair_profile" && complete.status === true).length > 0,
				beautyConcern: profileDataStep?.filter((complete) => complete.step === "complete_beauty_concern" && complete.status === true).length > 0,
				verifyEmail: dataComplete?.account_status?.filter((complete) => complete.description === "complete_account_allo" && complete.status === true).length > 0,
			};

		} else {

			completing = {
				personalInfo: profileDataStep?.filter((complete) => complete.step === "complete_personal_info" && complete.status === true).length > 0,
				beautyProfile: profileDataStep?.filter((complete) => complete.step === "complete_skin_profile" && complete.status === true).length > 0 && profileDataStep?.filter((complete) => complete.step === "complete_hair_profile" && complete.status === true).length > 0,
				beautyConcern: profileDataStep?.filter((complete) => complete.step === "complete_beauty_concern" && complete.status === true).length > 0,
				verifyEmail: profileDataStep?.filter((complete) => complete.step === "complete_verify_email" && complete.status === true).length > 0,
			};

		}

		const completingPercentage = ((Object.values(completing).filter((completeValues) => completeValues === true).length) / Object.values(completing).length) * 100;

		const CompletingStatus = {
			detail: completing,
			value: completingPercentage,
		};

		return CompletingStatus;

	};

	const updateSearchText = (e) => {

		setSearchText(e.target.value);

		if (

			(searchText.length > 0 && !isMobile) || (searchText.length > 1 && isMobile)

		) {

			setShowSearch(true);
			setShowSearchResult(true);

		} else {

			setShowSearchResult(false);

		}

	};

	const onSetDataLayer = (keyword = "", type = "", action = "click") => {

		setDataLayer({
			event: "typing_keyword_on_search",
			data: {
				user_keywords_referral: `${getData.storeSelf?.data?.username || "guest"}, ${searchText}, fromglobalheaderfdreviews${router.pathname.split("/")[1].replace(/[-]/g, "")}, ${action} ${type} ${keyword}, ${isMobile ? "mobile" : "desktop"}`,
			},
		}, "GTM");

		setDataLayer({
			event: "typing_keyword_on_search",
			device: `${isMobile ? "mobile" : "desktop"}`,
			is_login: !!getData.storeSelf?.data?.username,
			keyword: searchText,
			referral: `fromglobalheaderfdreviews${router.pathname.split("/")[1].replace(/[-]/g, "")}`,
			username: `${getData.storeSelf?.data?.username || "guest"}`,
			action,
			type,
			title: keyword,
		}, "GTM");

	};

	const handleGoToSearchPage = (value) => {

		window.location.href = `${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/search?q=${encodeURIComponent(value || searchText)}&tab=all`;

	};

	const handleSubmitHistory = (value) => {

		Fetching({
			method: "POST",
			url: "submitHistorySearch",
			data: {
				data: {

					keyword: value || searchText,
				},
				authorization: Cookies.get("token"),
			},
		})
			.then((res) => {

				handleGoToSearchPage(value);

				if (res.status === 200 || res.status === 201) {

					setDataHistory([...DataHistory, searchText]);

				}

			})
			.catch((err) => {

				console.log(`Error get data: ${err}`);

			});

	};

	const submitSearch = (e, value) => {

		e.preventDefault();
		onSetDataLayer("", "", "enter");

		const authorization = Cookies.get("token");

		if (!authorization) {

			handleGoToSearchPage(value);

		} else {

			handleSubmitHistory(value);

		}

	};

	const handleReloadData = () => {

		dispatch(
			loadSearchDefault({
				headers: Env.HEADERS,
				is_server: true,
				Authorization: Cookies.get("token") || "",
			}),
		);

	};

	const showSearch = () => {

		if (!isMobile) {

			setShowSearch(true);

		} else {

			setShowSearchInput(true);
			handleReloadData();
			setShowSearch(true);

		}

	};

	const handleCategoryList = () => {

		setIsShowCategoryMenu((state) => !state);

	};

	const handleCloseCategoryMobile = () => {

		setIsShowCategoryMenu(false);
		setIsCategorySidebarOpen(false);

	};

	const handleToggleSidebar = () => {

		setIsShowSidebar((state) => !state);

	};

	const handleBackSidebar = () => {

		setIsCategorySidebarOpen(false);
		setIsShowCategoryMenu(false);
		setIsShowSidebar(true);

	};

	const handleCategoryListSidebar = () => {

		setIsShowCategoryMenu(true);
		setIsShowSidebar(false);
		setIsCategorySidebarOpen(true);

	};

	const handleModalAdd = () => {

		setIsShowModalAdd(true);

	};

	const handleCloseModalAdd = () => {

		setIsShowModalAdd(false);

	};

	const handleBanner = (placement) => {

		Fetching({
			method: "POST",
			url: "getBanner",
			data: {
				placement,
			},
		})
			.then((res) => {

				if (res.data.meta.code === 200) {

					setBannerRibbon((data) => [...data, ...res.data.data]);

				} else {

					console.log(`${res.data.meta.msg}`);

				}

			})
			.catch((err) => {

				console.log(`Error get data: ${err}`);

			});

	};
	useEffect(() => {

		setDataHistory(getData.storeSearchDefault?.data?.history);

	}, [getData.storeSearchDefault?.data?.history]);

	useEffect(() => {

		let interval;
		if (
			(searchText.length >= 3 && !isMobile)
			|| (searchText.length > 2 && isMobile)
		) {

			setIsLoadingSearch(true);
			interval = setTimeout(() => {

				setDataLayer({
					event: "typing_keyword_on_search",
					username: getData.storeSelf?.data?.username || "guest",
					is_login: !!getData.storeSelf?.data?.username,
					device: isMobile ? "mobile" : "desktop",
					keyword: searchText,
					referral: `fromglobalheaderfdbr${router.pathname.split("/")[1].replace(/[-]/g, "")}`,
				}, "GTM");

				onSetDataLayer("", "", "typing");

				dispatch(
					loadQuickSearch({
						payload: {
							headers: Env.HEADERS,
							is_server: true,
							keyword: searchText.length ? searchText.replace(/[^a-zA-Z0-9_. -]/g, "") : "",
						},
					}),
				);

			}, 1000);

		}

		return () => {

			setIsLoadingSearch(false);
			clearTimeout(interval);

		};

	}, [searchText]);

	useEffect(() => {

		Fetching({
			method: "GET",
			url: "getSearchCampaign",
			payload: {
				headers: Env.HEADERS,
			},
		})
			.then((res) => {

				if (res.data.meta.code === 200) {

					setSeacrhCampaign(res.data.data);

				} else {

					console.log(`${res.data.meta.msg}`);

				}

			})
			.catch((err) => {

				console.log(`Error get data: ${err}`);

			});

	}, []);

	const deleteHistorySearch = (params) => {

		Fetching({
			method: "PATCH",
			url: "deleteHistorySearch",
			data: {
				data: {

					keywords: params,
				},
				authorization: Cookies.get("token") || "",
			},
		})
			.then((res) => {

				if (res.status === 200 || res.status === 201) {

					handleReloadData();

				}

			})
			.catch((err) => {

				console.log(`Error get data: ${err}`);

			});

	};

	const clearHistorySearch = () => {

		Fetching({
			method: "PATCH",
			url: "clearHistorySearch",
			data: {
				authorization: Cookies.get("token") || "",
			},
		})
			.catch((err) => {

				console.log(`Error get data: ${err}`);

			});

	};

	useEffect(() => {

		if (getData.storeQuickSearch?.status === "fetch_loading" || getData.storeQuickSearch?.status === "fetch_init") {

			setDataHistory(getData.storeSearchDefault?.data?.history);
			setIsLoadingSearch(true);

		} else {

			setIsLoadingSearch(false);

		}

	}, [getData.storeQuickSearch.status]);

	useEffect(() => {

		if (getData.storeSearchDefault?.status === "fetch_loading" || getData.storeSearchDefault?.status === "fetch_init") {

			setIsLoadingDefault(true);

		} else {

			setIsLoadingDefault(false);
			setIsLoadingSearch(false);

		}

	}, [getData.storeSearchDefault.status]);

	const handleNotif = () => {

		const auth = Cookies.get("token");

		if (auth) {

			getNotification({
				method: "POST",
				Authorization: auth,
			})
				.then((res) => {

					if (res.data.meta.code === 200) {

						if (typeof res.data?.data?.total_unseen === "number") {

							setIsNotifBadge(res.data?.data?.total_unseen > 0);

						}

					} else {

						console.log(`${res.data.meta.msg}`);

					}

				})
				.catch((err) => {

					if (process.env.NEXT_PUBLIC_NODE_ENV !== "production") {

						console.log(`Error get data: ${err}`);

					}

				});

		}

	};

	useEffect(() => {

		handleBanner(isMobile ? "ribbon_banner_mobile" : "ribbon_banner_desktop");

		handleNotif();

		if (!isMobile) {

			window.addEventListener("scroll", () => {

				if (document.documentElement.scrollTop > 84) {

					setToggleTopMenu(true);

				} else {

					setToggleTopMenu(false);

				}

			});

		}

	}, []);

	useEffect(() => {

		// handling ads
		setTimeout(() => {

			const adsmediumrectangle = document.getElementsByClassName(
				"ads-medium-rectangle",
			);
			const adsmediumrectangle1 = document.getElementsByClassName(
				"ads-medium-rectangle1",
			);
			const adsmediumrectangle2 = document.getElementsByClassName(
				"ads-medium-rectangle2",
			);
			const adsbillboard = document.getElementsByClassName("ads-billboard");
			const adsWrapper = [];

			if (adsmediumrectangle.length) {

				Object.entries(adsmediumrectangle).map((item, index) => {

					if (
						item[1].innerHTML === ""
						|| item[1].innerHTML === " "
						|| item[1].offsetHeight === 0
					) {

						adsWrapper.push(adsmediumrectangle[index].parentNode);

					}

				});

			}

			if (adsmediumrectangle1.length) {

				Object.entries(adsmediumrectangle1).map((item, index) => {

					if (
						item[1].innerHTML === ""
						|| item[1].innerHTML === " "
						|| item[1].offsetHeight === 0
					) {

						adsWrapper.push(adsmediumrectangle1[index].parentNode);

					}

				});

			}

			if (adsmediumrectangle2.length) {

				Object.entries(adsmediumrectangle2).map((item, index) => {

					if (
						item[1].innerHTML === ""
						|| item[1].innerHTML === " "
						|| item[1].offsetHeight === 0
					) {

						adsWrapper.push(adsmediumrectangle2[index].parentNode);

					}

				});

			}

			if (adsbillboard.length) {

				Object.entries(adsbillboard).map((item, index) => {

					if (
						item[1].innerHTML === ""
						|| item[1].innerHTML === " "
						|| item[1].offsetHeight === 0
					) {

						adsWrapper.push(adsbillboard[index]);

					}

				});

			}

			adsWrapper.map((item) => (item.innerHTML !== "" || item.innerHTML !== " "
				? (item.innerHTML = "")
				: null));

			if (!isMobile) {

				const beautyFilesSection = document.getElementsByClassName(
					"beauty-files-section",
				);

				if (beautyFilesSection.length > 0) {

					const adsBeautyFiles = beautyFilesSection[0].getElementsByClassName(
						"ads-medium-rectangle",
					);

					if (adsBeautyFiles.length === 0) {

						beautyFilesSection[0].classList.add("ads-empty");

					} else {

						beautyFilesSection[0].classList.remove("ads-empty");

					}

				}

			}

			// injectAltImage("btn_ads_close_top_frame", "close button ads top");
			// injectAltImage("btn_ads_close_bottom_frame", "close button ads bottom");

		}, 5000);

	}, []);

	// expand search history
	useEffect(() => {

		if (isShowSearch) {

			setExpandHistory(true);

		}

	}, [isShowSearch]);

	useEffect(() => {

		setHistoryHeight(ref?.current?.offsetHeight);

	}, [ref?.current?.offsetHeight]);

	useEffect(() => {

		const profile = getData.storeSelf.data;
		let tempUser = {
			user_id: "",
			skin_type: "",
			skin_tone: "",
			skin_undertone: "",
			hair_type: "",
			colored_hair: "",
			hijaber: "",
			skin_concern: "",
			body_concern: "",
			hair_concern: "",
		};

		const tempPage = {
			platform: props.ismobile ? "mobile" : "dekstop",
			page_type: props.pageType ? props.pageType : "",
		};

		const tempProduct = {
			product_name: "",
			brand_name: "",
			product_shade: "",
			review_number: "",
			overall_rating: "",
			recommend: "",
			first_timer: "",
			category: "",
			product_skin_type: "",
			product_skin_tone: "",
			product_skin_undertone: "",
			product_hair_type: "",
			product_skin_concern: "",
			product_body_concern: "",
			product_hair_concern: "",
			create_date: "",
			is_user_verified: false,
		};

		if (profile) {

			tempUser = {
				user_id: profile.user_id ? encryptString(profile.user_id) : "",
				skin_type: profile.beauty_profile ? profile.beauty_profile.skin_type_name : "",
				skin_tone: profile.beauty_profile ? profile.beauty_profile.skin_tone_name : "",
				skin_undertone: profile.beauty_profile ? profile.beauty_profile.skin_undertone_name : "",
				hair_type: profile.beauty_profile ? profile.beauty_profile.skin_hairtype_name : "",
				colored_hair: profile.beauty_profile
					? !profile.beauty_profile.hair_color || profile.beauty_profile.hair_color === 0
						? ""
						: Vars.COLORED_HAIR.filter(
							(data) => data.id === profile.beauty_profile.hair_color,
						)[0].name
					: "",
				hijaber: profile.beauty_profile
					? !profile.beauty_profile.is_hijab || profile.beauty_profile.is_hijab === 0
						? ""
						: Vars.HIJAB.filter(
							(data) => data.id === profile.beauty_profile.is_hijab,
						)[0].name
					: "",
				skin_concern: profile.beauty_concern
					? profile.beauty_concern.hair.map((data) => data.name).join(", ")
					: "",
				body_concern: profile.beauty_concern
					? profile.beauty_concern.skin.map((data) => data.name).join(", ")
					: "",
				hair_concern: profile.beauty_concern
					? profile.beauty_concern.body.map((data) => data.name).join(", ")
					: "",
			};

		}

		window.dataLayer = window.dataLayer || [];
		window.dataLayer = window.dataLayer.filter((item) => !item.page_type);
		const gtm = {
			...tempUser,
			...tempProduct,
			...tempPage,
		};

		window.dataLayer.push(gtm);

		if (process.env.NEXT_PUBLIC_ALLO_STATUS === "ON") {

			if (!Cookies.get("alloPopup") && !getData.storeSelf.data.mpc_id) {

				Cookies.set("alloPopup", JSON.stringify({
					isShow: true,
					expiryTime: null,
				}), { domain: `.femaledaily.${process.env.NEXT_PUBLIC_NODE_ENV === "production" ? "com" : "net"}` });
				SetIsShowAlloPopup(true);

			} else if (Cookies.get("alloPopup") && getData.storeSelf.data.mpc_id) {

				Cookies.remove("alloPopup", { domain: `.femaledaily.${process.env.NEXT_PUBLIC_NODE_ENV === "production" ? "com" : "net"}` });

			} else {

				const checkAlloCookie = () => {

					try {

						JSON.parse(Cookies.get("alloPopup"));

					} catch (e) {

						return false;

					}
					return JSON.parse(Cookies.get("alloPopup"));

				};

				const alloPopupCookie = checkAlloCookie();

				if (typeof alloPopupCookie === "object") {

					if (alloPopupCookie.isShow === true) {

						SetIsShowAlloPopup(true);

					} else if (alloPopupCookie.isShow === false && alloPopupCookie.expiryTime < (new Date()).getTime()) {

						SetIsShowAlloPopup(true);
						Cookies.set("alloPopup", JSON.stringify({
							isShow: true,
							expiryTime: null,
						}), { domain: `.femaledaily.${process.env.NEXT_PUBLIC_NODE_ENV === "production" ? "com" : "net"}` });

					}

				} else {

					Cookies.remove("alloPopup");
					Cookies.set("alloPopup", JSON.stringify({
						isShow: true,
						expiryTime: null,
					}), { domain: `.femaledaily.${["canary", "production"].includes(process.env.NEXT_PUBLIC_NODE_ENV) ? "com" : "net"}` });

				}

			}

		}

	}, []);

	const handleAlloMenuNavbar = () => {

		if (isMobile) {

			setIsShowSidebar((state) => !state);

		}

		setIsAlloExplorePopup(true);

	};

	const handleCloseModalAllo = () => {

		setIsAlloExplorePopup(false);

	};

	const onClickCompleteProfile = () => {

		const pageReferer = window.location.href;
		window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/complete-profile?url=${pageReferer}`;

	};

	const gotoProductMatches = () => {

		window.location.href = `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/product-matches?ref=fromfdbrsubnavbar`;

	};

	const handleButtonVerif = () => {

		if (getData.storeSelf.data.id) {

			if (getData.storeCompleting.status === "fetch_result") {

				const completingPercentage = calculateCompletingPercentage().value;
				const completingDetail = calculateCompletingPercentage().detail;

				const flagBeautyID = process.env.NEXT_PUBLIC_ALLO_STATUS === "ON" ? getData.storeCompleting?.data?.data.is_profile_complete : (completingDetail.beautyProfile && completingDetail.beautyConcern);

				if (completingPercentage < 100 && !flagBeautyID) {

					setModalCompleteProfileCta(true);
					setDataLayer()?.viewPopupCompleteProfile({
						username: getData?.storeSelf?.data?.username,
						is_login: !!getData?.storeSelf?.data?.username,
						device: getData?.isMobile ? "mobile" : "desktop",
						referral: "fromheaderproductmathcesreviews",
					});

				} else {

					gotoProductMatches();

				}

			} else {

				dispatch(
					loadCompleting({
						payload: {
							api_env: process.env.NEXT_PUBLIC_NODE_ENV,
							headers: Env.HEADERS,
							usrname: Cookies.get("usrname"),
							Authorization: Cookies.get("token"),
							is_server: true,
						},
					}),
				);

				setTimeout(() => {

					const completingPercentage = calculateCompletingPercentage().value;

					if (completingPercentage < 100) {

						setModalCompleteProfileCta(true);

					} else {

						gotoProductMatches();

					}

				}, 3000);

			}

		} else if (!getData.storeSelf.data.id) {

			if (process.env.NEXT_PUBLIC_ALLO_STATUS === "ON") {

				SetIsShowAlloPopup(true);

			} else {

				window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}?url=${window.location.href}`;

			}

		}

	};

	const listenToScroll = () => {

		const heightToShowFrom = 1000;
		const winScroll = document.body.scrollTop
			|| document.documentElement.scrollTop;

		if (winScroll > heightToShowFrom) {

			setIsVisible(true);

		} else {

			setIsVisible(false);

		}

	};

	useEffect(() => { // get completing user percentage

		if (getData.storeSelf?.data?.id) {

			dispatch(
				loadCompleting({
					payload: {
						api_env: process.env.NEXT_PUBLIC_NODE_ENV,
						headers: Env.HEADERS,
						usrname: Cookies.get("usrname"),
						Authorization: Cookies.get("token"),
						is_server: true,
					},
				}),
			);

		}

	}, []);

	const searchOnClick = () => {

		setShowSearch(true);
		if (searchText.length <= 0
			&& !getData.storeSearchDefault?.data?.trending
			&& getData.storeSearchDefault?.meta?.code !== 200) {

			dispatch(
				loadSearchDefault({
					headers: Env.HEADERS,
					is_server: true,
					Authorization: Cookies.get("token") || "",
				}),
			);

		}

		setDataLayer({
			event: "click_search",
			username: getData.storeSelf?.data?.username || "guest",
			is_login: !!getData.storeSelf?.data?.username,
			device: isMobile ? "mobile" : "desktop",
			keyword: searchText,
			referral: `fromglobalheaderfdbr${router.pathname.split("/")[1].replace(/[-]/g, "")}`,
		}, "GTM");

	};

	useEffect(() => {

		window.addEventListener("scroll", listenToScroll);
		return () => window.removeEventListener("scroll", listenToScroll);

	}, []);

	useEffect(() => {

		const checkNavbarHeight = setTimeout(() => {

			if (!isMobile) {

				const navbarHeight = document.getElementsByClassName("navbar-header").length ? document.getElementsByClassName("navbar-header")[0].offsetHeight : 0;
				setNavHeight(() => navbarHeight);

			} else {

				const navbarHeight = document.getElementsByClassName("navbar-header").length ? document.getElementsByClassName("navbar-header")[0].offsetHeight : 0;
				setNavHeight(() => navbarHeight);

			}

		}, 2000);

		return () => clearTimeout(checkNavbarHeight);

	}, []);

	// check user verified status
	const [isUserVerified, setUserVerified] = useState(null);
	const checkUserVerified = () => {

		const dataCompleting = getData?.storeCompleting?.data?.data;
		if (process.env.NEXT_PUBLIC_ALLO_STATUS === "ON") {

			if (dataCompleting?.is_complete_profile) {

				return true;

			}

			if (dataCompleting?.account_status?.filter((completion) => completion?.description === "complete_account_allo" && completion?.status === true).length) {

				return true;

			}
			return false;

		}

		const nonAlloStatusVerified = dataCompleting?.account_status?.filter((completion) => (completion?.description === "complete_verify_email" || completion?.description === "complete_verify_phone") && completion?.status === true);
		return nonAlloStatusVerified?.length === 2;

	};

	const handleDataLayerBrand = (referral) => {

		setDataLayer({
			event: "view_brand_list",
			device: isMobile ? "mobile" : "desktop",
			referral,
			is_login: !!getData.storeSelf?.data?.username,
			username: getData.storeSelf?.data?.username || "guest",
		}, "GTM");

	};

	const handleDataLayerAddReview = () => {

		setDataLayer({
			event: "click_add_review",
			username: getData.storeSelf?.data?.username || "guest",
			is_login: !!getData.storeSelf?.data?.username,
			device: isMobile ? "mobile" : "desktop",
			referral: "fromsubnavbarfdbr",
		}, "GTM");

	};

	const handleUnregisterFcmResviceWorker = () => {

		if ("serviceWorker" in navigator) {

			navigator.serviceWorker.getRegistrations().then((registrations) => {

				registrations.forEach((service) => {

					if (service.active.scriptURL.includes("firebase-messaging-sw.js")) service.unregister();

				});

			});

		}

	};
	const handlerRedirectToSsoLogout = () => {

		window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/logout`;

	};
	const handleLogout = async () => {

		const fcmTkn = Cookies.get("fcm_tkn");
		const token = Cookies.get("token") || "";
		const deviceId = Cookies.get("device_id");

		if (!fcmTkn) {

			Cookies.remove("perssitent_id", {
				domain: `.femaledaily.${["production", "staging"].includes(process.env.NEXT_PUBLIC_NODE_ENV)
					? "com"
					: "net"
				}`,
			});

			handlerRedirectToSsoLogout();
			return;

		}
		await fetchFcmDelete({
			authorization: token,
			body: {
				device_id: deviceId,
			},
		})
			.then(() => {

				Cookies.remove("alreadyRegis");
				Cookies.remove("fcm_tkn");
				Cookies.remove("perssitent_id", {
					domain: `.femaledaily.${["production", "staging"].includes(process.env.NEXT_PUBLIC_NODE_ENV)
						? "com"
						: "net"
					}`,
				});
				Cookies.remove("platform_id", {
					domain: `.femaledaily.${process.env.NEXT_PUBLIC_NODE_ENV === "development" ? "net" : "com"
					}`,
				});
				Cookies.remove("device_id");

			})
			.catch(() => { })
			.finally(() => {

				handleUnregisterFcmResviceWorker();
				handlerRedirectToSsoLogout();

			});

	};

	// condition for notif fcm
	useEffect(async () => {

		const token = Cookies.get("token") || "";

		// kondisi ini ketika buka tab dimana, tab app pertama sudah logout dan token sudah terhapus
		const handleCheck = () => {

			const fcmToken = Cookies.get("fcm_tkn");
			const jwtToken = Cookies.get("token") || "";
			const deviceId = Cookies.get("device_id");
			const perssist = Cookies.get("perssitent_id");
			const platform = Cookies.get("platform_id");

			const oldDeviceId = deviceId?.match(/^([a-z0-9]+-\d+)/i);

			// disaat membuka tab dan membandingkan antara deviceId tidak sesuai dengan perssis id, maka cookies fcm dkk akan dihapus
			// kondisi ketika sudah logout serta relogin dan perssisId update deviceId baru
			if (oldDeviceId?.[1] !== perssist) {

				Cookies.remove("fcm_tkn");
				Cookies.remove("device_id");
				Cookies.remove("alreadyRegis");

			}

			// disaat buka tab kedua ketika tidak ada toke dan fcm blm terhapus, maka cookies fcm dkk dihapus
			if (fcmToken && !jwtToken) {

				Cookies.remove("fcm_tkn");
				Cookies.remove("perssitent_id", {
					domain: `.femaledaily.${["production", "staging"].includes(
						process.env.NEXT_PUBLIC_NODE_ENV,
					)
						? "com"
						: "net"
					}`,
				});
				Cookies.remove("device_id");
				Cookies.remove("alreadyRegis");

			}

			if (perssist && !jwtToken) {

				Cookies.remove("perssitent_id", {
					domain: `.femaledaily.${["production", "staging"].includes(
						process.env.NEXT_PUBLIC_NODE_ENV,
					)
						? "com"
						: "net"
					}`,
				});

			}

			if (platform && !jwtToken) {

				Cookies.remove("platform_id", {
					domain: `.femaledaily.${process.env.NEXT_PUBLIC_NODE_ENV === "development" ? "net" : "com"
					}`,
				});

			}

		};

		// Trigger on tab becoming visible
		const handleTabActive = () => {

			if (document.visibilityState === "visible") {

				handleCheck();

			}

		};

		if (!token) {

			handleUnregisterFcmResviceWorker();

		}

		// refresh
		handleCheck();
		document.addEventListener("visibilitychange", handleTabActive);

		return () => {

			document.removeEventListener("visibilitychange", handleTabActive);

		};

	}, []);

	useEffect(() => {

		const idPlatform = Cookies.get("platform_id");
		if (idPlatform && "serviceWorker" in navigator) {

			navigator.serviceWorker.ready.then((registration) => {

				if (registration.active) {

					registration.active.postMessage({ idPlatform });

				}

			});

		}

	}, []);

	useEffect(() => {

		if (typeof window !== "undefined" && !window.dataLayer) {

			window.dataLayer = [];

		}

	}, []);

	useEffect(() => {

		if (getData?.storeCompleting?.status === "fetch_result") {

			setUserVerified(checkUserVerified());

		}

	}, [getData.storeCompleting?.status]);

	return (
		<div id="layout-top">

			{/* Detik Ads */}
			{props.adsHead && <div dangerouslySetInnerHTML={{ __html: props.adsHead }} />}
			{props.adsFoot && <div dangerouslySetInnerHTML={{ __html: props.adsFoot }} />}

			<Notification isMobile={!!isMobile} />
			{checkLoginStatus() && <FcmNotification isMobile={!!isMobile} />}

			<ModalWarning isMobile={isMobile} />

			<div className="navbar-header-wrapper">
				<NavbarHeader
					onClickLogout={handleLogout}
					is_mobile={isMobile}
					isNewIcon
					custom_notif_url={`${process.env.NEXT_PUBLIC_SSO_DOMAIN}/user/notification`}
					is_notif_badge={isNotifBadge}
					nav_width="1200px"
					type="monochrome"
					self={getData.storeSelf.data}
					is_user_verified={isUserVerified}
					menu={isMobile ? Vars.top_menu_mobile : Vars.top_menu}
					main_link={process.env.NEXT_PUBLIC_ROOT_DOMAIN}
					home_link={process.env.NEXT_PUBLIC_ROOT_HOME}
					reviews_link={process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}
					talk_link={process.env.NEXT_PUBLIC_TALK_DOMAIN}
					sso_link={process.env.NEXT_PUBLIC_SSO_DOMAIN}
					sidebar_config={Vars.CONFIG_SUB_NAV}
					profile_link={`${process.env.NEXT_PUBLIC_SSO_DOMAIN}/user/fd/${getData.storeSelf.data.username}`}
					setting_link={`${process.env.NEXT_PUBLIC_SSO_DOMAIN}/account/fd`}
					logo_id="id_logo_editorial"
					logo_img={
						process.env.NEXT_PUBLIC_MALE_DAILY_MODE === "ON"
							? process.env.NEXT_PUBLIC_MALE_DAILY_LOGO
							: undefined
					}
					search_input_id="id_search_input_field_editorial"
					button_login_id="id_loginsignup_editorial"
					button_cart_id="id_carteditorial"
					button_notif_id="id_notifeditorial"
					total_unread_notif={parseInt(TotalNotifReviews, 10) + parseInt(TotalNotifTalks, 10)}
					submit_search={submitSearch}
					search_text={searchText}
					update_search_text={updateSearchText}
					toggle_sidebar={handleToggleSidebar}
					close_search_wrapper={() => {

						setSearchText("");
						setShowSearchInput(false);
						setShowSearch(false);

					}}
					// is_article_loading={isArticlesResultLoading}
					// is_product_loading={isProductsResultLoading}
					// is_user_loading={isUsersResultLoading}
					// is_brand_loading={isBrandsResultLoading}
					is_show_search_suggest={isShowSearch}
					is_show_search_result={isShowSearchResult}
					is_show_search={isShowSearchInput}
					is_show_sidebar={isShowSidebar}
					// is_user_verified={isUserVerified}
					show_search={showSearch}
					// products={products}
					// brands={brands}
					// users={users}
					// articles={articles}
					hide_search={() => {

						setSearchText("");
						setShowSearch(false);
						setShowSearchInput(false);

					}}
					is_hide_top_menu={isHidetopMenu}
					handle_category_list_sidebar={handleCategoryListSidebar}
					onClickLoginSignup={() => {

						if (process.env.NEXT_PUBLIC_ALLO_STATUS === "ON") {

							if (isMobile) {

								setIsShowSidebar(false);
								SetIsShowAlloPopup(true);

							} else {

								SetIsShowAlloPopup(!IsShowAlloPopup);

							}

						} else {

							window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}?url=${window.location.href}`;

						}

					}}
					// allo explore handle
					handleAlloExplorer={handleAlloMenuNavbar}
					profilePopupCustomElement={
						getData.storeSelf?.data?.mpc_id && process.env.NEXT_PUBLIC_ALLO_STATUS === "ON"
							? (
								<AlloSectionProfilePopup
									onClickAlloCoupon={handleAlloMenuNavbar}
								/>
							)
							: null
					}
					// onBlurInput={() => setTimeout(() => setShowSearch(false), 500)}
					SisterSites={
						[
							{
								name: "Mommies Daily",
								value: "md",
								pathname: process.env.NEXT_PUBLIC_MD_DOMAIN,
								query: "",
								visible: true,
								new: false,
							},
							{
								name: "Female Daily Studio",
								value: "bs",
								pathname: process.env.NEXT_PUBLIC_ECM_DOMAIN,
								query: "",
								visible: true,
								new: false,
							},
							{
								name: "Girls Beyond",
								value: "gb",
								pathname: process.env.NEXT_PUBLIC_GB_DOMAIN,
								query: "",
								visible: true,
								new: false,
							},
						]
					}
					eventImage={bannerRibbon[0]?.image || process.env.NEXT_PUBLIC_RIBBON_IMAGE}
					eventURL={bannerRibbon[0]?.url || process.env.NEXT_PUBLIC_RIBBON_URL}
					search_on_click={searchOnClick}
					// search_on_keyDown={searchInput}
					search_placeholder={searchCampaign.campaign_name}
					brandsLink={`${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/brands`}
					elementIdBrands="id_brands"
					onClickBrand={handleDataLayerBrand.bind(null, "fromsidebarfdbr")}
				>
					{
						isShowSearch
							&& (
								<NavbarHeader.SearchWrapper>
									{
										IsLoadingSearch
											? (
												<div className="loader-wrapper">
													<img
														src="https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/global-header/loader_blink.gif"
														className="loader-gif"
														alt="loader-blink"
													/>
												</div>
											)
											: searchText.length >= 3
												? 									(
													<QuickSearch
														isMobile={isMobile}
														defaultPictureProfile={Vars.BROKEN_IMAGE.user}
														defaultPicture={Vars.BROKEN_IMAGE.square}
														limitDataBrand={5}
														limitDataProduct={4}
														limitDataService={4}
														limitDataArticle={3}
														limitDataUser={3}
														limitDataSuggest={3}
														dataBrand={getData.storeQuickSearch?.data?.results?.brands || []}
														dataProduct={getData.storeQuickSearch?.data?.results?.products || []}
														dataService={getData.storeQuickSearch?.data?.results?.services || []}
														dataArticle={getData.storeQuickSearch?.data?.results?.articles || []}
														dataUsers={getData.storeQuickSearch?.data?.results?.users || []}
														suggestions={getData.storeQuickSearch?.data?.suggestions || []}
														submitSearch={submitSearch}
														onSetDataLayer={onSetDataLayer}
														searchText={searchText}
													/>
												)
												:	(
													<SearchDefault
														isMobile={isMobile}
														IsLoadingDefault={IsLoadingDefault}
														limitDataBrand={5}
														limitDataProduct={4}
														limitDataArticle={3}
														limitDataPromotion={3}
														limitDataHistory={5}
														dataPromotion={getData.storeSearchDefault?.data?.promotion?.section}
														titlePromotion={getData.storeSearchDefault?.data?.promotion?.name}
														searchHistory={getData.storeSearchDefault?.data?.history}
														titlePopular={getData.storeSearchDefault?.data?.popular?.name}
														dataBrand={getData.storeSearchDefault?.data?.popular?.section?.filter((item) => item.type === "brand")[0]?.data || []}
														dataProduct={getData.storeSearchDefault?.data?.popular?.section?.filter((item) => item.type === "product")[0]?.data || []}
														dataArticle={getData.storeSearchDefault?.data?.popular?.section?.filter((item) => item.type === "article")[0]?.data || []}
														trending={getData.storeSearchDefault?.data?.trendings}
														searchText={searchText}
														deleteHistorySearch={deleteHistorySearch}
														clearHistorySearch={clearHistorySearch}
														defaultPicture={Vars.BROKEN_IMAGE.rectangle}
														historyHeight={historyHeight}
														setHistoryHeight={setHistoryHeight}
														expandHistory={expandHistory}
														setExpandHistory={setExpandHistory}
														ExpandRef={ref}
														submitSearch={submitSearch}
														onSetDataLayer={onSetDataLayer}
													/>
												)
									}
								</NavbarHeader.SearchWrapper>
							)
					}
					{
						isShowSearch && isMobile
							? null
							: (
								<NavbarHeader.ChildrenWrapper>

									<div className="subnav-wrapper">
										<SubNav
											isMobile={isMobile}
											host={process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}
											subnav_config={Vars.CONFIG_SUB_NAV}
											self={getData.storeSelf.data}
											// nav_active={navActive}
											handle_category_list={handleCategoryList}
											element_id_add_review="id_addreviewreview"
											element_id_add_product="id_addproductreview"
											element_id_category="id_category"
											element_id_feed="id_feed"
											element_id_product_matches="id_product_matches"
											// user_completing_precentage={checkUserProfileConcern(
											// 	state.init_steps,
											// 	state.current_step,
											// )}
											handleButtonVerif={() => handleButtonVerif()}
											show_modal_add={isShowModalAdd}
											handle_modal_add={handleModalAdd}
											close_modal_add={handleCloseModalAdd}
											sso_link={process.env.NEXT_PUBLIC_SSO_DOMAIN}
											brandsLink={`${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/brands`}
											elementIdBrands="id_brands"
											add_review_link={`${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/add-review`}
											onClickBrand={handleDataLayerBrand.bind(null, "fromsubnavbarfdbr")}
											onClickAddReview={handleDataLayerAddReview}
										/>
									</div>

									{ isShowCategoryMenu ? (
										<>
											<Category
												isMobile={!!isMobile}
												onClickClose={handleCloseCategoryMobile}
												onClickBack={handleBackSidebar}
												headerType={isCategorySidebarOpen ? "femaledaily" : "default"}
											/>
											<style>
												{`
													.navbar-header {
														box-shadow: none !important;
													}
													.brand-container{
														width: 100%;
													}
												`}
											</style>
										</>
									) : null }
								</NavbarHeader.ChildrenWrapper>
							)
					}

				</NavbarHeader>

				{!isMobile && props.isShowTopBanner && (
					<div className="top-frame">
						<Banner
							name="topframe"
							placeholder="topframe"
							is_mobile={isMobile}
							class_name="topframe"
						/>
					</div>
				)}
			</div>

			<ModalCompleteProfileCta
				isMobile={isMobile}
				isShow={isModalCompleteProfileCta}
				onClose={() => setModalCompleteProfileCta(false)}
				onClickCompleteProfile={onClickCompleteProfile}
				onClickLater={() => setModalCompleteProfileCta(false)}
				percentage={`${calculateCompletingPercentage().value}%`}
			/>

			<style>
				{`
					.sidebar .profile-option:nth-child(1) {
						display: none;
					}
					.loader-wrapper {
						display: flex;
						align-items: center;
						justify-content: center;
					}

					.left-category-list {
						margin-top: 0 !important;
					}
					.list-group-icon {
						width: 205px !important;
						height: 32px !important;
					}

					// img {
					//   max-width: 100%;
					//   max-height: 100%;
					//   width: auto;
					//   height: auto;
					// }

					// .navbar-header {
					//   background-color: #FFF;
					// }

					.search-input-field input {
						font-family: "Creato Display";
						display: block;
						max-width: calc(100% - 32px);
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}
					.search-button:focus,
					.search-input-field input:focus::placeholder {
						font-family: "Creato Display";
						display: block;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis;
					}

					.search-input-field::placeholder,
					.search-input-field:focus::placeholder,
					.search-input-field input::placeholder {
						font-family: "Creato Display";
						display: block;
						white-space: nowrap;
						overflow: hidden;
						text-overflow: ellipsis !important;
						max-width: 94%;
					}

					.product-result {
						box-sizing: border-box;
					}

					.brand-card {
						flex-wrap: nowrap;
					}

					.sub-menu-title a {
						text-transform: uppercase;
					}

					.menu-popup {
						max-width: calc(100% - 48px);
					}

					img.sub-menu-item {
						max-width: 100%;
					}

					.left-category-list {
						width: 247px !important;
						// margin-top: 0 !important;
						// height: fit-content !important;
						// padding: 22px 32px !important;
					}

					.top-frame {
						position: sticky;
						top: 0px;
						left: 0;
						right: 0;
						z-index: 2;
						display: flex;
						justify-content: center;
					}

					.fdn-modal {
						animation: none !important;
					}

					@media (max-width: 768px) {
						.navbar-header .btn-close {
							margin-left: 0;
						}

						.navbar-header .mega-menu {
							padding-bottom: 0;
						}

						.mega-menu-wrapper {
							width: 100%;
							max-width: 100%;
							margin-top: 12px;
							display: unset;
							justify-content: unset;
						}

						.navbar-header .search-popup-content {
							max-width: calc(100% - 32px);
						}

						.menu-popup {
							max-width: unset;
						}

						.menu-popup-title {
							justify-content: space-between;
						}
					}
					.search-wrapper__container {
						min-height: ${isMobile ? "calc(100vh - 4em)" : "100%"};
					}
					.child-component-wrapper {
						height: ${isMobile ? "100%" : "auto"};
					}

					.top-menu .menus a {
						cursor: pointer;
					}

					.profile-popup {
						width: 100%;
					}
				`}
			</style>
			<style jsx global="true">
				{`
					a {
						text-decoration: none;
					}

					body {
						margin: 0px;
						max-width: 100%;
						overflow-x: hidden;
					}
				`}
			</style>

			<div className="main-content">

				{props.children}

				{
					props.isShowBottomBanner && (

						isMobile ? (
							<Banner
								name="stickystaticbanner"
								placeholder="stickystaticbanner"
								is_mobile={isMobile}
								class_name="ads-stickystaticbanner"
							/>
						) : (
							<Banner
								name="bottomframe"
								placeholder="bottomframe"
								is_mobile={isMobile}
								class_name="ads-bottomframe"
							/>
						)
					)
				}

				<style>
					{`
						.ads-bottomframe,
						.ads-stickystaticbanner {
							width: 100%;
							position: fixed;
							bottom: -4px;
							display: flex;
							justify-content: center;
							z-index:2
						}
						.ads-bottomframe {
							bottom: -4px;
						}
						.top-frame {
							top: 0px;
						}
						.navbar-header-placeholder {
							height: 0px;
						}
						.navbar-header-wrapper {
							position: sticky;
							top: 0px;
							z-index: 2;
						}
					`}
				</style>
			</div>

			<AlloExploreModal
				isMobile={isMobile}
				isShow={isAlloExplorePopup}
				onClick={handleCloseModalAllo}
			/>
			{
				IsShowAlloPopup
				&& (
					<>
						<AlloMain
							isMobile={isMobile}
							query={{}}
							hostDomain={`.femaledaily.${["canary", "production"].includes(process.env.NEXT_PUBLIC_NODE_ENV) ? "com" : "net"}`}
							ssoDomain={process.env.NEXT_PUBLIC_SSO_DOMAIN}
							// errorOffsetTop={state.navHeight + "px"}
							closeElement={() => SetIsShowAlloPopup(false)}
							// fetchMPC={(data) => FetchMPC(data)}
							// login={(data) => login(data)}
							// loginVerifyCode={(data) => login_verify_code(data)}
							// forgotPassword={(data) => forgot_password(data)}
							// registerCompleteAccount={(data) => register_complete_account(data)}
							onClickMigrateAccount={() => {

								const pageReferer = window.location.href;
								window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}?url=${pageReferer}`;

							}}
							onClickLoginRegister={() => {

								const pageReferer = window.location.href;
								window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}?url=${pageReferer}`;

							}}
							helpUrl={`${process.env.NEXT_PUBLIC_ROOT_HOME}/help?tab=account`}
						/>
						<style>
							{`
								.fdn-modal {
									animation: none !important;
								}
							`}
						</style>
					</>
				)
			}

			{
				isVisible && <ScrollTop isMobile={isMobile} button_top_id="layout-top" ScrollToUp={ScrollToUp} />
			}

			<Footer
				isMobile={isMobile}
			/>

		</div>
	);

};

Layout.propTypes = {
	ismobile: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.bool,
	]).isRequired,
	pageType: PropTypes.string,
	adsHead: PropTypes.string,
	adsFoot: PropTypes.string,
	isShowSubNav: PropTypes.bool,
	isShowTopBanner: PropTypes.bool,
	isShowBottomBanner: PropTypes.bool,
	children: PropTypes.element,
};

Layout.defaultProps = {
	pageType: null,
	adsHead: null,
	adsFoot: null,
	isShowSubNav: true,
	isShowTopBanner: true,
	isShowBottomBanner: true,
	children: <></>,
};
export default Layout;
